if(!customElements.get('localization-drawer')) {
  customElements.define('localization-drawer', class localizationDrawer extends Drawer {
    constructor() {
      super();
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-language-link]');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const alternate = Array.from(document.querySelectorAll('link[rel="alternate"][hreflang]'))
          .find((item) => item.hreflang === link.dataset.languageCode);
        const destination = new URL(alternate?.href || link.href, window.location.origin);
        if (destination.origin !== window.location.origin) return;
        destination.search = window.location.search;
        destination.hash = window.location.hash;
        event.preventDefault();
        try {
          window.localStorage.setItem('translation-lab-lang', link.dataset.languageCode);
          window.sessionStorage.removeItem('tlab.redirectHistory');
        } catch (error) {}
        document.cookie = `translation-lab-lang=${encodeURIComponent(link.dataset.languageCode)}; path=/; domain=${window.location.hostname}; Max-Age=31536000; Secure; SameSite=Lax`;
        window.location.assign(destination.href);
      });


      this.searchInput = document.getElementById('Localization-Search');
      if(!this.searchInput) return;

      this.searchField = this.searchInput.parentElement;
      this.resetButton = this.searchField.querySelector('.reset-button');
      this.regionCountry = document.getElementById('Region-Country-Filter-Results');
      this.regionLanguage = document.getElementById('Region-Language-Filter-Results');

      this.previousValue = '';

      this.searchInput.addEventListener('keyup', this.onKeyup.bind(this));
      this.resetButton.addEventListener('click', this.resetFilter.bind(this));
    }

    /**
     * 处理搜素过滤
     */
    onKeyup() {
      const searchValue = webvista.normalizeString(this.searchInput.value);
      if(searchValue === this.previousValue) return;

      this.previousValue = searchValue;
      this.toggleResetButton();

      const allCountries = this.querySelectorAll('.country-list > li');
      let visibleCountryCount = 0;
      allCountries.forEach(element=>{
        const countryName = webvista.normalizeString(element.querySelector('.country').textContent);
        if (countryName.indexOf(searchValue) > -1) {
          element.classList.remove('hidden');
          visibleCountryCount++;
        } else {
          element.classList.add('hidden');
        }
      });
      if(this.regionCountry) this.regionCountry.textContent = window['accessibilityStrings']['countrySelectorFilterCount'].replace('[count]', visibleCountryCount);

      const allLanguages = this.querySelectorAll('.language-list > li');
      let visibleLanguageCount = 0;
      allLanguages.forEach(element=>{
        const languageName = webvista.normalizeString(element.querySelector('.language').textContent);
        if (languageName.indexOf(searchValue) > -1) {
          element.classList.remove('hidden');
          visibleLanguageCount++;
        } else {
          element.classList.add('hidden');
        }
      });
      if(this.regionLanguage) this.regionLanguage.textContent = window['accessibilityStrings']['languageSelectorFilterCount'].replace('[count]', visibleLanguageCount);

      // 重新进入焦点陷阱，防止逃逸
      const drawerTrap = this.querySelector('[data-trap]');
      if(drawerTrap) webvista.trapFocus(drawerTrap, this.searchInput);
    }

    resetFilter() {
      this.searchInput.value = '';
      this.onKeyup();
      this.searchInput.focus();
    }

    toggleResetButton() {
      this.resetButton.classList.toggle('hidden', !this.searchInput.value);
    }
  });
}
